import { createContext } from 'react'
import type { OfferPageState } from './offerPageStateReducer'
import { INITIAL_OFFER_PAGE_STATE } from './offerPageStateReducer'

const OfferPageStateContext = createContext<OfferPageState>(INITIAL_OFFER_PAGE_STATE)

export default OfferPageStateContext
